import React from 'react'
import BackButton from './BackButton.js'
import MenuButton from './MenuButton.js'
import ShareButton from './ShareButton.js'
import './header.css';

class Header extends React.Component {

  render() {
    if (this.props.backbutton === true) {
      this.button = <BackButton />
    }
    else {
      if (this.props.menucallback !== undefined) {
        this.button = <MenuButton callback={this.props.menucallback}/>
      } else {
        this.button = null
      }
    }
    return <div style={{
      //marginRight: "calc(-1 * (100vw - 100%))" Keep this for future reference, this stops the scrollbar moving the header.
    }} className="pageHeader">
    {this.button}
      <p className='headerTitle'>
        {this.props.title}
      </p>           
      <ShareButton />
  </div>
}
}

export default Header